import { translate } from './translation';

export const isAtMaxQuantity = (row) =>
  row.maxPurchaseQuantity !== null &&
  row.maxPurchaseQuantity !== undefined &&
  parseFloat(row.quantity) >= row.maxPurchaseQuantity;

export const maxQuantityText = (row) =>
  translate('cart.maxquantity', 'Endast {0} st kan beställas just nu').replace(
    '{0}',
    row.maxPurchaseQuantity
  );
